import React from 'react';

import { FaqViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { TextArea } from 'components/WrappedComponents';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';

import { FaqFieldProps, FaqFormValues } from '../../../types';

import './InputContent.less';

function TextAreaContent({
  values,
  validateField,
}: FaqFieldProps): React.ReactElement {
  const key: keyof FaqFormValues = 'content';

  return (
    <TextArea
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          rules: [
            {
              required: true,
              validator: async (_rule, value): Promise<void> => {
                return await validateField(
                  key,
                  FaqViolationDtoFormFieldEnum.CONTENT,
                  value,
                );
              },
            },
          ],
        },
      }}
      textAreaProps={{
        placeholder: FormPlaceholders.Input,
        bordered: false,
        autoSize: true,
      }}
    />
  );
}

export default TextAreaContent;
